import DataRoomInvitationCard from './DataRoomInvitationCard.component';

export default DataRoomInvitationCard;
